import {chain} from 'lodash';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {getAnswers} from '../../../../../store/data/answers/answersSelectors';
import {getQuickResponsesIds} from '../../../../../store/data/preferences/preferencesSelectors';
import {AnswersToolbarButton} from './answersToolbarButton';

/*
 * Selectors.
 */

function makeGetQuickReponses() {
  return createSelector([getQuickResponsesIds, getAnswers], (quickResponsesIds, answers) =>
    chain(quickResponsesIds)
      .map((id) => {
        if (!id) {
          return undefined;
        }

        const quickAnswer = answers[id];
        if (!quickAnswer) {
          return undefined;
        }

        return quickAnswer;
      })
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  quickResponses: makeGetQuickReponses(),
}));

export const AnswersToolbarButtonContainer = connect(mapStateToProps)(AnswersToolbarButton);
